// extracted by mini-css-extract-plugin
module.exports = {"sortContainer":"SortToggles_sortContainer__3o8-U","sortItem":"SortToggles_sortItem__2JU3y","sortLabel":"SortToggles_sortLabel__1EAsT","active":"SortToggles_active__DhTOm"};